/**
 * SocialPulseFooter — quiet editorial footer for the new home. Three
 * column groups + a wordmark row. No emoji, no rainbow tagline.
 */
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";

const GROUPS = [
  {
    title: "Network",
    links: [
      ["Explore Places", "/places"],
      ["Explore Topics", "/topics"],
      ["Community",      "/community"],
      ["Causes",         "/causes"],
      ["Full Network",   "/network"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About SocialPulse",  "/about"],
      ["Meet the Founder",   "/founder"],
      ["Vision & Mission",   "/vision-mission"],
      ["Press",              "/press"],
      ["Careers",            "/careers"],
    ],
  },
  {
    title: "Support",
    links: [
      ["Help Centre",        "/help"],
      ["Contact Us",         "/contact"],
      ["Community Guidelines", "/community-guidelines"],
      ["Terms of Service",   "/terms"],
      ["Privacy Policy",     "/privacy"],
    ],
  },
];

export default function SocialPulseFooter() {
  return (
    <footer
      className="pt-14 pb-8"
      style={{
        background:
          "linear-gradient(180deg, #F5F1FA 0%, #EDE7F6 45%, #E8F5EC 100%)",
        color: "#334155",
      }}
      data-testid="sp-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="w-9 h-9 grid place-items-center rounded-xl bg-gradient-to-br from-emerald-500 to-violet-600 text-white shadow-sm">
                <Activity className="w-4 h-4" strokeWidth={2.5} />
              </span>
              <span className="font-serif font-bold text-slate-900 text-xl tracking-tight">
                SocialPulse<span className="text-slate-500 text-sm align-top">®</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-slate-600 leading-relaxed max-w-xs">
              One identity, many pulses. A network of community-first sites
              connecting people, places and purpose.
            </p>
          </div>
          {GROUPS.map((g) => (
            <div key={g.title}>
              <h4 className="font-semibold text-slate-900 text-sm uppercase tracking-widest mb-4">
                {g.title}
              </h4>
              <ul className="space-y-2.5 text-sm">
                {g.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-slate-600 hover:text-violet-700 transition-colors">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-violet-200/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} SocialPulse Inc. All rights reserved.</p>
          <p className="italic text-emerald-700/80">Different places. Brighter people. A stronger tomorrow.</p>
        </div>
      </div>
    </footer>
  );
}
